// 统一合并为完整的 Locale
var locale = {
  lang: {
    reset: 'reset',
    search: 'search',
    expand: 'open',
    collapse: 'close'
  }
};
export default locale;